import { lazy, Suspense, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import useSoundMixer from "../hooks/useSoundMixer";
import useSleepTimer from "../hooks/useSleepTimer";
import PlaybackControls from "./PlaybackControls";
import Sound from "./Sound";
import SoundList from "./SoundList";
import { normalizePathname } from "../utils/pathname";
const CalmGallery = lazy(() => import("./CalmGallery"));

const NatureTouch = () => {
  const mixer = useSoundMixer();
  const { masterVolume, setMasterVolume, sounds, volumes, playingSounds, isPaused, setVolume, togglePlay, playMix, pause, resume, clear } = mixer;
  const pathname = normalizePathname(useLocation().pathname);
  const isGallery = pathname === "/gallery";
  const [calmScene, setCalmScene] = useState(null);
  useEffect(() => { if (!isGallery) setCalmScene(null); }, [isGallery]);
  const timer = useSleepTimer(pause);
  const [headerSlot, setHeaderSlot] = useState(null);
  useEffect(() => { setHeaderSlot(document.getElementById("mixer-header-controls")); }, []);
  const cancelTimer = timer.cancel;
  useEffect(() => {
    if (playingSounds.length === 0) cancelTimer();
  }, [playingSounds.length, cancelTimer]);
  const handleResetClick = () => {
    timer.cancel();
    clear();
  };
  const controls = <PlaybackControls
    masterVolume={masterVolume}
    onMasterVolumeChange={setMasterVolume}
    hasMix={playingSounds.length > 0}
    isPaused={isPaused}
    onTogglePause={isPaused ? resume : pause}
    timer={timer}
    showTimer={!(isGallery && calmScene)}
  />;

  return (
    <>
      <SEO url={pathname} />
      <h1 className="sr-only">{isGallery ? 'Nature image gallery' : pathname === '/saved' ? 'Saved sound mixes' : 'Nature sound mixer'}</h1>
      {headerSlot && !(isGallery && calmScene) && createPortal(controls, headerSlot)}
      <div className="mixer-page">
        <SoundList
          sounds={sounds}
          playMix={playMix}
          handleResetClick={handleResetClick}
          gallery={isGallery && <Suspense fallback={<div className="calm-gallery-loading" role="status">Loading scenes…</div>}><CalmGallery mixer={mixer} controls={controls} calmScene={calmScene} onCalmSceneChange={setCalmScene} onLeaveCalm={handleResetClick} /></Suspense>}
        />
        {!isGallery && <div className="sound-grid">
          <Sound
            sounds={sounds}
            volumes={volumes}
            playingSounds={playingSounds}
            isPaused={isPaused}
            setVolume={setVolume}
            togglePlay={togglePlay}
          />
        </div>}
      </div>
    </>
  );
};

export default NatureTouch;
